import React from "react"
import { FormProvider } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { FormProviderProps } from "shared/types/ReactHookForm"
import { FormOverlay } from "shared/ui/overlay/FormOverlay"

import { FeedbackImageInput } from "./FeedbackImageInput"
import { FeedbackMessageInput } from "./FeedbackMessageInput"
import { FeedbackOverlayFormData } from "./FeedbackOverlay"

export interface FeedbackOverlayViewModel {
  headline: string
  methods: FormProviderProps<FeedbackOverlayFormData>
  onSubmit: (ev: React.FormEvent) => void
  onCancel: () => void
}

export const FeedbackOverlayView = React.memo(
  ({ headline, methods, onSubmit, onCancel }: FeedbackOverlayViewModel) => {
    const { t } = useTranslation()
    return (
      <FormOverlay
        id="feedback-overlay"
        prefix="feedback-overlay"
        form="feedback-form"
        headline={headline}
        submitButtonText={t("General.Send")}
        onCancel={onCancel}
        showCloseButton
      >
        <FormProvider {...methods}>
          <form id="feedback-form" className="overlay-form" onSubmit={onSubmit}>
            <FeedbackMessageInput />
            <FeedbackImageInput />
          </form>
        </FormProvider>
      </FormOverlay>
    )
  }
)
